import { createFileRoute } from "@tanstack/react-router";
import { AccountRecoveryScreen } from "@modules/account/views";
export const Route = createFileRoute("/account-recovery")({
  component: AccountRecoveryScreen,
});
